import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Form,
  Spinner,
} from 'reactstrap';
import { useUrlSearchParams } from 'use-url-search-params';
import { DateRangePicker } from 'rsuite';
import moment from 'moment';
import { exportDonations } from '../actions/action';

function DonationExportReport() {
  const [params] = useUrlSearchParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { afterToday, combine, allowedMaxDays } = DateRangePicker;
  
  const [startDate, setStartDate] = useState(
    moment().format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(
    moment().format('YYYY-MM-DD')
  );

  const { country = [] } = useSelector((state) => state.country);
  let currentCountry = localStorage.getItem('WEBSITE_COUNTRY');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await exportDonations({
        params: {
          export_type: 'donations',
          excel_type: 'donations',
          date_from: startDate,
          date_to: endDate || startDate,
          country: currentCountry,
          status: params?.status === 'All' ? '' : params?.status,
          search_qry: params?.search || '',
        },
        dispatch,
      });
    } catch (error) {
      console.error('Export error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="donation-export-container">
      <Form onSubmit={handleSubmit}>
        <div className="DashbordFliter d-flex justify-content-end align-items-center">
            <div className="InputBg me-2">
                <DateRangePicker
                    placement="leftStart"
                    placeholder="Select Date Range"
                    onClean={() => {
                        setStartDate(moment().format('YYYY-MM-DD'));
                        setEndDate(moment().format('YYYY-MM-DD'));
                    }}
                    disabledDate={combine(allowedMaxDays(365), afterToday())}
                    onChange={(selectedDates) => {
                      if (selectedDates && selectedDates.length === 2) {
                        setStartDate(moment(selectedDates[0]).format('YYYY-MM-DD'));
                        setEndDate(moment(selectedDates[1]).format('YYYY-MM-DD'));
                      }
                    }}
                />
            </div>
            <button
                type="submit"
                className="btn btn-dark d-flex align-items-center"
                disabled={loading}
            >
                {loading && (
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                    />
                )}
                Export
                <i className="bx bx-download ms-2" style={{ fontSize: '18px' }}></i>
            </button>
        </div>
      </Form>
    </div>
  );
}

export default DonationExportReport;
